import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=5154ea70&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=js"
export * from "./AttachmentList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&id=5154ea70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154ea70",
  null
  
)

export default component.exports